//
//
//
//
//
//

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'LoadingButton',
  props: {
    type: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'primary'
    },
    styleClass: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    loadingLabel: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loadingLabelString () {
      const loadingLabel = this.loadingLabel ? this.loadingLabel : this.$t('chat.loading')
      return this.loading ? loadingLabel : this.label
    }
  }
}
